import ScenarioService from "@/services/scenario.service";
import Logo from "@/modules/fptai/components/Logo";

const { NodeType } = ScenarioService

function createTreeNodeAction ({ layoutConfig, PortalSourceMap, MapNodeTypeToClassName, nodeSelection, actions, nodes }) {
    return nodeSelection.enter()
        .append("g")
        .attr("transform", d => `translate(${d.x * layoutConfig.columnWidth},${d.y * layoutConfig.rowHeight})`)
        .attr("class", d => 'g-node ' + MapNodeTypeToClassName[d.data.type])
        .attr('id', d => d.id)
        .on("click", actions.onNodeSelected)
        .on("mouseover", d => {
            if (d.data.type === NodeType.PORTAL) {
                let node = PortalSourceMap[d.data.id]
                if (node) {
                    let el = document.getElementById(node.id)
                    if (el) el.classList.add('highlight')
                    nodes.filter(
                        item => item.data.type === NodeType.PORTAL && item.data.config.id === node.id
                    ).forEach(
                        item => {
                            let el = document.getElementById(item.data.id)
                            if (el) el.classList.add('highlight')
                        }
                    )
                }
            } else {
                let el = document.getElementById(d.data.id)
                if (el) el.classList.add('highlight')
                for (let idNode of Object.keys(PortalSourceMap)) {
                    let node = PortalSourceMap[idNode]
                    if (node.id === d.data.id) {
                        let el = document.getElementById(idNode)
                        if (el) el.classList.add('highlight')
                    }
                }
            }
        })
        .on("mouseout", d => {
            if (d.data.type === NodeType.PORTAL) {
                let node = PortalSourceMap[d.data.id]
                if (node) {
                    let el = document.getElementById(node.id)
                    if (el) el.classList.remove('highlight')
                    nodes.filter(
                        item => item.data.type === NodeType.PORTAL && item.data.config.id === node.id
                    ).forEach(
                        item => {
                            let el = document.getElementById(item.data.id)
                            if (el) el.classList.remove('highlight')
                        }
                    )
                }
            } else {
                let el = document.getElementById(d.data.id)
                if (el) el.classList.remove('highlight')
                for (let idNode of Object.keys(PortalSourceMap)) {
                    let node = PortalSourceMap[idNode]
                    if (node.id === d.data.id) {
                        let el = document.getElementById(idNode)
                        if (el) el.classList.remove('highlight')
                    }
                }
            }
        })
        .on('contextmenu', function (d, i) {
            // d3.event.preventDefault();
            if (actions.onNodeContextMenu) {
                actions.onNodeContextMenu(d, i)
            }
        });
}

export default createTreeNodeAction
